import React from 'react';
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
  EmailShareButton,
  EmailIcon,
} from 'react-share';

const text = 'Drive Uber without owning a car. Sign up for Autzu and get $50! Terms and conditions apply.';
const SocialLinksGroup = ({ url }) => (
  <div className="social__container">
    <FacebookShareButton quote={text} url={url}>
      <FacebookIcon size={48} round />
    </FacebookShareButton>
    <TwitterShareButton title={text} url={url}>
      <TwitterIcon size={48} round />
    </TwitterShareButton>
    <WhatsappShareButton title={text} url={url}>
      <WhatsappIcon size={48} round />
    </WhatsappShareButton>
    <EmailShareButton subject={text} body={`${text} ${url}`} url={url}>
      <EmailIcon size={48} round />
    </EmailShareButton>
  </div>
);

export default SocialLinksGroup;



// WEBPACK FOOTER //
// ./src/components/Referral/SocialLinksGroup.js